<template>
  <v-navigation-drawer right id="drawer" permanent absolute temporary width="400">
    <div style="position: fixed; top: 0; width: 100%; background-color: white; z-index: 1">
      <v-list-item>
        <v-list-item-title>
          <h3>Chat</h3>
        </v-list-item-title>
        <v-list-item-action>
          <v-btn icon>
            <v-icon v-on:click="toggleChat" color="grey lighten-1">{{mdiClose}}</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>
    </div>

    <v-list style="margin-top: 50px; margin-bottom: 50px;">
      <v-list-item v-for="(item, itemId) in messages" :key="itemId">
          <v-list-item-avatar>
            <v-img :src="getRandomAvatar(item.name)"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle v-if="isServerMessage(item.value)" class="text-wrap" style="text-align: left">
              {{getServerMessage(item.value)}}
            </v-list-item-subtitle>
            <v-list-item-title v-else class="text-wrap" style="text-align: left">
              {{item.value}}
            </v-list-item-title>
          </v-list-item-content>
      </v-list-item>
    </v-list>

    <div style="position: absolute; bottom: 0; width: 100%; background-color: white; z-index: 1;">
      <v-row>
        <v-col cols="1">
          <v-avatar style="margin-left: 5px; margin-top: 8px; width: 30px"><img :src="getRandomAvatar(userId)"></v-avatar>
        </v-col>
        <v-col cols="11">
          <v-text-field ref="focus" autofocus style="margin-left: 20px; margin-right: 10px" v-model="message" clearable placeholder="Write a message..." :append-outer-icon="mdiSend" @keyup.enter="sendMessage" @click:append-outer="sendMessage"></v-text-field>
        </v-col>
      </v-row>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mdiClose, mdiSend } from '@mdi/js'

export default {
  name: 'chat',
  data () {
    return {
      mdiClose, 
      mdiSend,
      message: ""
    }
  },
  props: {
    messages: Array,
    userId: String
  },
  methods: {
    getRandomAvatar: function (name) {
      return `https://api.dicebear.com/5.x/${this.$store.state.selectedStyle}/svg?seed=${name}&radius=50&b=%2365c9fe`
    },
    sendMessage: function() {
      this.$socket.emit('message', { tableId: this.$router.currentRoute.path.slice(1), userId: this.userId, value: this.message })
      this.message = ""
    },
    toggleChat: function () {
      this.$store.commit('toggleChat')
    },
    isServerMessage: function(message) {
      return message.startsWith('[S]')
    },
    getServerMessage: function(message) {
      return message.replace('[S]', '')
    }
  }
}
</script>
